import { render, staticRenderFns } from "./AverageTemperature.vue?vue&type=template&id=e13fdb5e&scoped=true&"
import script from "./AverageTemperature.vue?vue&type=script&lang=ts&"
export * from "./AverageTemperature.vue?vue&type=script&lang=ts&"
import style0 from "./AverageTemperature.vue?vue&type=style&index=0&id=e13fdb5e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13fdb5e",
  null
  
)

export default component.exports